export default __webpack_public_path__ + "static/img_8-712d76586aa902c43c52b1f0d40f95cb.png";